<template>
    <div>
        <div class="tab-wrapper">
            <div class="tab-item"
                 v-for="item in options"
                 :key="item.name"
                 @click="chanegActive(item)"
                 :style="{background:activeRoute===item.name?color:''}"
                 :class="{active:activeRoute===item.name}">{{item.text}}</div>
        </div>
        <keep-alive>
            <router-view class="content-wrapper"></router-view>
        </keep-alive>
    </div>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: '#44ab34'
        },
        options: {
            type: Array
        }
    },
    computed: {
        activeRoute() {
            return this.$route.name
        }
    },
    methods: {
        chanegActive({ name }) {
            this.$router.replace({ name })
        }
    },
}
</script>

<style scoped lang='less'>
.tab-wrapper {
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    text-align: center;
    .tab-item {
        width: 6.5rem;
        height: 1.8rem;
        line-height: 1.8rem;
        color: #a2a2a2;
        background: #f2f2f2;
        transition: background, color 0.5s ease-out;
    }
    .active {
        color: #fff;
    }
}
.content-wrapper {
    padding: 1.2rem 1rem;
}
</style>